import { render, staticRenderFns } from "./LearningCourse.vue?vue&type=template&id=68c155e6"
import script from "./LearningCourse.vue?vue&type=script&lang=js"
export * from "./LearningCourse.vue?vue&type=script&lang=js"
import style0 from "./LearningCourse.vue?vue&type=style&index=0&id=68c155e6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports